import { render, staticRenderFns } from "./LandingEvaluation.vue?vue&type=template&id=48160dfd&scoped=true"
import script from "./LandingEvaluation.vue?vue&type=script&lang=js"
export * from "./LandingEvaluation.vue?vue&type=script&lang=js"
import style0 from "./LandingEvaluation.vue?vue&type=style&index=0&id=48160dfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48160dfd",
  null
  
)

export default component.exports